






































































import i18n from 'vue-i18n';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoMultiSelect from '@/components/Molecules/co-multiselect/CoMultiSelect.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import { SignUpField as SignUpFieldType } from '@/types/auth';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';

export default {
    name: 'SignUpField',
    components: { CoText, CoCheckbox, CoInput, CoSelect, CoMultiSelect, CoFormGroup, CoPill },
    props: {
        field: { type: Object as () => SignUpFieldType, required: true },
        value: { type: [String, Number, Boolean, Array], default: '' },
    },
    computed: {
        inputId() {
            return `signup-field-${this.field.Key}`;
        },
        inputType() {
            // Phone values are text so leading plus signs and zeros survive input.
            if (this.field.Key === 'phone') return 'tel';
            return ({ 1: 'number', 2: 'date', 6: 'url' } as Record<number, string>)[this.field.Type] || 'text';
        },
        options() {
            return (this.field.Options || []).map((option) => ({ Name: option, Value: option }));
        },
        selectedValue() {
            return this.options.find((option) => option.Value === this.value) || { Value: '', Name: '' };
        },
        selectedValues() {
            return this.options.filter((option) => Array.isArray(this.value) && this.value.includes(option.Value));
        },
    },
};
